import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, branch, renderComponent } from 'recompose'
import cx from 'classnames'
import IconSVG from 'svg-inline-react'
import * as MessageSelectors from 'app/modules/message/selectors'
import { updateUserProperties } from 'app/modules/user/properties/actions'
import * as UserPropertiesSelectors from 'app/modules/user/properties/selectors'
import { ClearbitRevealConvoPreview } from 'components/ClearbitRevealPreview'
import LinkedinSection from './../LinkedinSection'
import { isIntegrationConnected } from 'utils/Integrations'
import CompanyDisplayNameMap from './CompanyDisplayNameMap'

import { Button } from '@driftt/tide-core-legacy'
import Header from './Header'
import Placeholder from './Placeholder'

import { Sidebar } from './style.styl'

import noCompanyInfoSrc from '!svg-inline?removeTags=true!images/svg/sidebar-no-company-data.svg'
import CompanyInfoProvider from "components/Presence/CompanyInfo/CompanyInfoProvider"

const Loading = () => {
  return (
    <div className={cx(Sidebar, 'placeholder')}>
      <Placeholder/>
    </div>
  )
}

const Empty = () =>
  <div className={cx(Sidebar, 'empty')}>
    <IconSVG className="no-company-info" src={noCompanyInfoSrc}/>
    <div className="no-company-info-text">
      We don&rsquo;t have any company data for this person.
    </div>
  </div>

const CompanyDataRow = ({ fieldData, displayName }) => (
  <div className="row">
    <div className="company-info">
      <div className="company-info-label">
        {displayName}
      </div>
      <div className="company-info-value">
        {fieldData}
      </div>
    </div>
  </div>
)

class Company extends Component {
  handleRedesignAcknowledged = () => {
    this.props.actions.updateUserProperties({
      notify: false,
      properties: { 'did_acknowledge_contact_sidebar_redesign': true }
    })
  }

  renderCompanyTabRedesignPopover = () => {
    return (
      <div className="company-tab-redesign-popover">
        <div className="title">
          More Room to Breathe
          <div className="badge"/>
        </div>
        <div className="body">We&rsquo;ve given Company profiles a new home so your conversations have more room to
          breathe.
        </div>
        <div className="footer">
          <Button onClick={this.handleRedesignAcknowledged} size="small">Got it!</Button>
        </div>
      </div>
    )
  }

  render() {
    const {
      companyData: {
        name,
        domain,
        logo,
        linkedInHandle,
        twitterHandle,
        source,
        url,
      },
      companyData,
      isCurrentUserEligibleForRedesignAnnouncement,
      hasLinkedin
    } = this.props

    const companyProvider = <CompanyInfoProvider provider={source}/>

    return (
      <div className={Sidebar}>
        <Header
          className="header-section"
          companyName={name}
          companyDomain={domain}
          companyUrl={url}
          companyLogo={logo}
          companyLinkedInHandle={linkedInHandle}
          companyTwitterHandle={twitterHandle}
        />
        {isCurrentUserEligibleForRedesignAnnouncement && this.renderCompanyTabRedesignPopover()}
        {canDisplayLinkedinSectionCompany(hasLinkedin, name, url) && <LinkedinSection companyName={name} companyUrl={url}/>}
        <div className="attributes-section">
          {
            Object.keys(CompanyDisplayNameMap).map((field) => {
              if (!!companyData[field]) {
                return <CompanyDataRow key={CompanyDisplayNameMap[field]} fieldData={companyData[field]} displayName={CompanyDisplayNameMap[field]}/>
              }
            })
          }
        </div>
        {!!companyProvider && (
          <div>
            {companyProvider}
          </div>
        )}
      </div>
    )
  }
}

const canDisplayLinkedinSectionCompany = (hasLinkedin, name, website) => {
  return hasLinkedin && !!(name || website)
}

const makeMapStateToProps = () => {

  return (state, props) => {
    const { conversationId } = props

    return {
      isCurrentUserEligibleForRedesignAnnouncement: UserPropertiesSelectors.isCurrentUserEligibleForContactSidebarRedesignAnnouncement(state),
      firstMessagesLoaded: MessageSelectors.firstMessagesLoaded(state, { conversationId }),
      firstMessagesLoading: MessageSelectors.firstMessagesLoading(state, { conversationId }),
      hasLinkedin: isIntegrationConnected('linkedin')
    }
  }
}

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({
    updateUserProperties
  }, dispatch),
})

export default compose(
  connect(makeMapStateToProps, mapDispatchToProps),
  branch(props => props.firstMessagesFailed, renderComponent(Empty)),
  branch(props => !props.firstMessagesLoaded, renderComponent(Loading)),
  branch(props => !props.ip && !props.email, renderComponent(Empty)),
  branch(props => !props.isCompanyDataLoaded, renderComponent(Loading)),
  branch(props => !props.isCompanyDataLoading && !props.companyData, renderComponent(Empty)),
  branch(props => _.every(props.companyData, (data) => !data || _.isEmpty(data)), renderComponent(Empty)),
)(Company)



// WEBPACK FOOTER //
// ./src/scripts/components/conversation/ContactSideBar/Company/index.js